import { objToUrlParams } from '@/utils'
import request from '@/utils/request'

// 充值订单列表接口
export const antTopupList = (params: any) =>
  request({
    url: `manage/ant-topup`,
    method: 'get',
    params
  })

// 统计接口
export const getStatistics = (params: any) =>
  request({
    url: `manage/ant-topup/statistics`,
    method: 'get',
    params
  })

// 修改订单接口
export const changeOrderStatus = (data: any) =>
  request({
    url: `manage/ant-topup/${data.name}/status`,
    method: 'put',
    data: data.body
  })

// 充值订单详情接口
export const getOrderDetail = (params: any) =>
  request({
    url: `manage/ant-topup/${params}`,
    method: 'get'
  })

// 归集设置
export const getCollectConfig = () =>
  request({
    url: `/manage/hidden-config`,
    method: 'get'
  })

// 归集设置
export const setCollectConfig = (data: any) =>
  request({
    url: `/manage/hidden-config`,
    method: 'put',
    data
  })

// 导出
export const orderAntExport = (data: any) =>
  request({
    url: '/manage/ant-topup-order-export' + objToUrlParams(data),
    method: 'post'
  })
